module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="tab-container">\n    <div class="record-header"></div>\n    <div class="tab-container-tabs"></div>\n    <div class="tab-container-records"></div>\n</div>';

}
return __p
}